export default "__VITE_ASSET__C56v49IG__"